import React from 'react';
import AlertToaster from '../../containers/AlertToaster';
import './index.css';

export default (props) => {
  return (
    <div className="App">
      <AlertToaster/>
      {props.routes}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/App/index.js